import React from 'react';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { MavoVehicleAttachment } from '../../interfaces/Vehicle';
import { MavoVehicelAttachementTypeCodeEnum } from '../../helpers/Constants';

interface IPreviewAttachmentState {
  currentIndex: number,
  scale: number,
}

interface IPreviewAttachmentProps {
  loadMavoAttachmentData: MavoVehicleAttachment[],
  currentIndex: number
  attachmentTypeId: number
}

class PreviewAttachment extends React.PureComponent<
  IPreviewAttachmentProps,
  IPreviewAttachmentState
> {

  state = {
    currentIndex: this.props.currentIndex,
    scale: 1,
  } as IPreviewAttachmentState;


  nextImage = () => {
    let nextIndex = (this.state.currentIndex + 1) % this.props.loadMavoAttachmentData?.length;
    while (this.props.loadMavoAttachmentData[nextIndex]?.attachmentTypeId !== this.props.attachmentTypeId) {
      nextIndex = (nextIndex + 1) % this.props.loadMavoAttachmentData?.length;
    }
    this.setState({
      currentIndex: nextIndex
    });
  };

  prevImage = () => {
    let prevIndex = this.state.currentIndex === 0 ? this.props.loadMavoAttachmentData?.length - 1 : this.state.currentIndex - 1;
    while (this.props.loadMavoAttachmentData[prevIndex]?.attachmentTypeId !== this.props.attachmentTypeId) {
      prevIndex = prevIndex === 0 ? this.props.loadMavoAttachmentData?.length - 1 : prevIndex - 1;
    }
    this.setState({
      currentIndex: prevIndex
    });
  };

  public render() {
    return (
      <div>
        <button
          className='navigateToGalleryButton'
          onClick={this.prevImage}
          style={{ left: '0px' }}
        >
          ‹
        </button>
        <button
          className='navigateToGalleryButton'
          onClick={this.nextImage}
          style={{ right: '0px' }}
        >
          ›
        </button>
        <TransformWrapper
          initialScale={1}
          minScale={1}
          maxScale={5}
          wheel={{ step: 0.1 }}
          doubleClick={{ step: 1 }}
        >
          {({ zoomIn, zoomOut }) => (
            <>
              <div
                style={{
                  position: "absolute",
                  bottom: "20px",
                  right: "20px",
                  display: "flex",
                  flexDirection: "row",
                  gap: "10px",
                  zIndex: 2
                }}
              >
                <button
                  onClick={() => zoomIn()}
                  className='zoomGalleryButton'
                >
                  +
                </button>
                <button
                  onClick={() => zoomOut()}
                  className='zoomGalleryButton'
                >
                  −
                </button>
              </div>
              {console.log(this.props.loadMavoAttachmentData)}
              <TransformComponent>
                <img
                  src={this.props.loadMavoAttachmentData[this.state.currentIndex].url || `data:img/png;base64,${this.props.loadMavoAttachmentData[this.state.currentIndex].content}`}
                  alt="Preview"
                  style={{
                    width: '100%',
                    height: '100%',
                    maxHeight: '70vh',
                    objectFit: 'contain',
                  }}
                />
              </TransformComponent>
            </>
          )
          }
        </TransformWrapper>
      </div>
    );
  }
}

export default PreviewAttachment
